export default __webpack_public_path__ + "static/media/icon-cognitive.b3f0a814.png";